import * as api from "../../api";


export const getserviceCardData =  async(assetId:string, serviceType:string, isServiceHistoryRequired:boolean) => {
    try{
     return await api.getServiceCard(assetId, serviceType, isServiceHistoryRequired)
    }catch(e:any){
      return (e)
    }
  }

  